import { Typography } from "@mui/material";
import {
  getIsAdminList,
  getUserLastActiveTimestamp,
} from "../../../../utils/search";
import { getPrettyDate } from "../../../../utils/timestamp";
import IntegrationImage from "../../integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../integrations/IntegrationsMapping";

export const getUserColumns = (colors, fetchedEntities, showLocalTime) => {
  const showDepartmentColumn = fetchedEntities.some(
    (entity) =>
      entity?.hibob_data?.department ||
      entity?.bamboohr_data?.department ||
      entity?.kandji_data?.department
  );
  const departmentColumn = showDepartmentColumn
    ? {
        department: {
          field: "department",
          headerName: "Department",
          minWidth: 140,
          flex: 0.5,
          align: "left",
          headerAlign: "left",
          disableReorder: true,
          valueGetter: (params) =>
            params.row?.hibob_data?.department ||
            params.row?.bamboohr_data?.department ||
            params.row?.kandji_data?.department,
          renderCell: (params) => (
            <Typography variant="caption">{params.value || "-"}</Typography>
          ),
        },
      }
    : {};

  return {
    ...departmentColumn,
    privileged_in: {
      field: "privileged_in",
      headerName: "Privileged In",
      flex: 0.5,
      minWidth: 140,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      resizable: false,
      valueGetter: (params) =>
        !params.row.admin_roles ? [] : getIsAdminList(params.row),

      valueFormatter: (params) =>
        params.value
          .map((source) => IntegrationsMapping[source].displayName)
          .join(", "),
      sortComparator: (v1, v2) => v1.length - v2.length,
      renderCell: (params) => {
        const maxToolsDisplay = 4;
        return (
          <>
            {params.value.length > 0 ? (
              params.value
                .map((integration) => (
                  <IntegrationImage
                    key={integration}
                    name={integration}
                    width={"40px"}
                  />
                ))
                .slice(0, maxToolsDisplay)
            ) : (
              <Typography variant="caption" sx={{ marginLeft: "15px" }}>
                -
              </Typography>
            )}
            {params.value.length > maxToolsDisplay
              ? `+${params.value.length - maxToolsDisplay}`
              : null}
          </>
        );
      },
    },
    last_active: {
      field: "last_active",
      headerName: "Last Active",
      minWidth: 130,
      flex: 0.5,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      resizable: false,
      valueGetter: (params) => getUserLastActiveTimestamp(params.row),
      valueFormatter: (params) =>
        params.value > 0 ? getPrettyDate(params.value, showLocalTime) : null,
      renderCell: (params) => (
        <Typography variant="caption" color={colors.grey_700}>
          {params.value > 0 ? getPrettyDate(params.value, showLocalTime) : "-"}
        </Typography>
      ),
    },
  };
};
